<template>
  <button
    :class="componentClasses"
    v-on="$listeners"
    :disabled="disabled || loading"
  >
    <div v-if="loading" class="flex justify-center content-center">
      <r-loading />
    </div>
    <slot v-else />
  </button>
</template>

<script>
/**
 * Define the RButton component
 */
export default {
  // set component name
  name: "r-button",

  // accept props
  props: {
    // if should be outlined color
    outline: {
      type: Boolean,
      default: false
    },

    // show only text
    text: {
      type: Boolean,
      default: false
    },

    // set the color of the button
    color: {
      type: String,
      default: "primary"
    },

    disabled: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  // calculated properties
  computed: {
    /**
     * Define the component classes
     */
    componentClasses() {
      return {
        "py-2": true,
        "px-4": true,
        "my-1": true,
        border: true,
        rounded: true,
        "outline-none": true,
        "font-semibold": true,
        "bg-gray-500": this.disabled && !this.loading,
        [`border-r-${this.color}`]: !this.disabled,
        "text-black": !this.text && this.outline,
        "text-white": !this.text && !this.outline,
        [`text-r-${this.color}`]: this.text,
        [`bg-r-${this.color}`]: !this.text && !this.outline && !this.disabled
      }
    }
  }
}
</script>
